export const blockIconsTextformattingNewspaperNew = (
	<span className='material-symbols-outlined'>newspaper</span>
);
